import { useContext } from "react";
import {
  AppflowContext,
  AppflowContextType,
} from "app/providers/AppflowProvider";

export const useAppflow = (): AppflowContextType => {
  const context = useContext(AppflowContext);
  if (!context) {
    throw new Error("useAppflow must be used within an AppflowProvider");
  }
  return context;
};